import React, { CSSProperties, FunctionComponent } from 'react';
import { Label, Input, Container } from './TextInput.style';
import ValidationError from './ValidationError';

interface Props {
  label?: string;
  value: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  containerStyle?: CSSProperties;
  testID?: string;
  name: string;
  disabled?: boolean;
  error?: string | false;
}

const TextInput: FunctionComponent<Props> = (props) => {
  return (
    <Container style={props.containerStyle}>
      {props.label && <Label htmlFor={props.name}>{props.label}</Label>}

      <Input
        disabled={props.disabled}
        id={props.name}
        name={props.name}
        data-testid={props.testID}
        value={props.value}
        onChange={(e) => props.onValueChange && props.onValueChange(e.target.value)}
        placeholder={props.placeholder}
        error={props.error}
      />

      <ValidationError error={props.error} />
    </Container>
  );
};

export default TextInput;
